import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-15" }
const _hoisted_2 = { class: "d-flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_class_dialog_container = _resolveComponent("class-dialog-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { "no-gutters": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_page_title, {
          value: _ctx.$t('features.nursery-web-school-setting-class')
        }, null, 8, ["value"]),
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_btn, {
          onClick: _ctx.openCreateDialog,
          color: "primary",
          variant: "flat"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { start: "" }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                _createTextVNode("mdi-plus", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('settings.createClass')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, {
      variant: "flat",
      class: "mt-4 pa-2",
      color: "grey-lighten-5"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { align: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "3",
                  class: "pl-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.yearFilterValue,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.yearFilterValue) = $event)),
                      disabled: _ctx.loading,
                      type: "number",
                      "hide-details": "auto",
                      variant: "outlined",
                      density: "compact"
                    }, {
                      "append-inner": _withCtx(() => [...(_cache[13] || (_cache[13] = [
                        _createElementVNode("span", { class: "text-medium-emphasis text-no-wrap align-self-center" }, "SY", -1)
                      ]))]),
                      _: 1
                    }, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "9",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      onClick: _ctx.listClass,
                      loading: _ctx.loading,
                      color: "primary",
                      variant: "flat",
                      class: "search-button"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.search')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_data_table, {
      class: "pt-6",
      headers: _ctx.headers,
      items: _ctx.classList,
      "items-per-page": -1,
      loading: _ctx.loading,
      color: "primary"
    }, {
      loading: _withCtx(() => [
        _createVNode(_component_v_skeleton_loader, { type: "table-tbody" })
      ]),
      "item.year": _withCtx(({ item }) => [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(item.year) + " ", 1),
          _createVNode(_component_v_tooltip, { bottom: "" }, {
            activator: _withCtx(({ props }) => [
              (item.isActive)
                ? (_openBlock(), _createBlock(_component_v_icon, _mergeProps({
                    key: 0,
                    class: "ml-1",
                    "x-small": "",
                    color: "success"
                  }, props), {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                      _createTextVNode("mdi-circle", -1)
                    ]))]),
                    _: 1
                  }, 16))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.currentYear')), 1)
            ]),
            _: 2
          }, 1024)
        ])
      ]),
      "item.childrenAge": _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(`${item.childrenAge} yrs`), 1)
      ]),
      "item.createdAt": _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(_ctx.formatDate(item.createdAt)), 1)
      ]),
      "item.edit": _withCtx(({ item }) => [
        _createVNode(_component_v_btn, {
          onClick: ($event: any) => (_ctx.clickClass(item)),
          disabled: _ctx.loading,
          color: "primary",
          small: "",
          variant: "flat",
          block: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.edit')), 1)
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ]),
      "item.children": _withCtx(({ item }) => [
        _createVNode(_component_v_btn, {
          onClick: ($event: any) => (_ctx.searchChildren(item.classId)),
          disabled: _ctx.loading,
          color: "primary",
          small: "",
          variant: "outlined",
          block: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('settings.childrenDetail')), 1)
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ]),
      "item.duplicate": _withCtx(({ item }) => [
        _createVNode(_component_v_btn, {
          onClick: ($event: any) => (_ctx.clickDuplicate(item)),
          disabled: _ctx.loading,
          color: "secondary",
          variant: "outlined",
          small: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { start: "" }, {
              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                _createTextVNode("mdi-file-multiple-outline", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('settings.duplicate')), 1)
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ]),
      bottom: _withCtx(() => [...(_cache[16] || (_cache[16] = []))]),
      _: 1
    }, 8, ["headers", "items", "loading"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.childrenDialog,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.childrenDialog) = $event)),
      width: "700px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('settings.childrenDetail')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_alert, {
                              type: "info",
                              variant: "outlined",
                              color: "primary",
                              density: "compact"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('settings.useCheckboxes')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_data_table, {
                              modelValue: _ctx.childrenList,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.childrenList) = $event)),
                              headers: _ctx.childrenTableHeaders,
                              items: _ctx.allChildrenList,
                              "item-value": "childId",
                              loading: _ctx.loading,
                              "show-select": "",
                              density: "compact",
                              "hide-default-footer": "",
                              "items-per-page": -1,
                              color: "primary"
                            }, {
                              "item.children": _withCtx(({ item }) => [
                                _createTextVNode(_toDisplayString(`${item.lastName} ${item.firstName}`), 1)
                              ]),
                              "item.gender": _withCtx(({ item }) => [
                                (item.gender == 'male')
                                  ? (_openBlock(), _createBlock(_component_v_chip, {
                                      key: 0,
                                      color: "light-blue",
                                      dark: "",
                                      small: ""
                                    }, {
                                      default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                        _createTextVNode("Male", -1)
                                      ]))]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_v_chip, {
                                      key: 1,
                                      color: "pink lighten-2",
                                      dark: "",
                                      small: ""
                                    }, {
                                      default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                        _createTextVNode("Female", -1)
                                      ]))]),
                                      _: 1
                                    }))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "headers", "items", "loading"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.childrenDialog = false)),
                          color: "grey",
                          text: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          onClick: _ctx.updateClassChildren,
                          loading: _ctx.loading,
                          color: "primary",
                          variant: "flat"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick", "loading"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.duplicateDialog,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.duplicateDialog) = $event)),
      width: "700px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_form, {
          modelValue: _ctx.duplicateFormValid,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.duplicateFormValid) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('settings.duplicateClass')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_container, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_alert, {
                                  color: "primary",
                                  variant: "outlined",
                                  type: "info",
                                  density: "compact"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('settings.childrenAutoAssigned')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, { align: "center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "6" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('settings.className')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "6" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.duplicateInput.to.className,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.duplicateInput.to.className) = $event)),
                                  rules: [_ctx.required],
                                  variant: "outlined",
                                  clearable: "",
                                  "hide-details": "",
                                  density: "compact"
                                }, null, 8, ["modelValue", "rules"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, { align: "center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "6" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('settings.targetYear')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "6" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.duplicateInput.to.year,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.duplicateInput.to.year) = $event)),
                                  rules: [_ctx.required],
                                  type: "number",
                                  variant: "outlined",
                                  "hide-details": "",
                                  density: "compact",
                                  suffix: _ctx.$t('setting.classDialog.year')
                                }, null, 8, ["modelValue", "rules", "suffix"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, { align: "center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "6" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('settings.childrenAge')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "6" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.duplicateInput.to.childrenAge,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.duplicateInput.to.childrenAge) = $event)),
                                  rules: [_ctx.required],
                                  type: "number",
                                  suffix: _ctx.$t('setting.classDialog.yearsOld'),
                                  variant: "outlined",
                                  "hide-details": "",
                                  density: "compact"
                                }, null, 8, ["modelValue", "rules", "suffix"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_container, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.duplicateDialog = false)),
                              color: "grey",
                              text: ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_v_btn, {
                              onClick: _ctx.duplicateClass,
                              loading: _ctx.loading,
                              disabled: !_ctx.duplicateFormValid,
                              color: "primary",
                              variant: "flat"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('settings.duplicate')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick", "loading", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_class_dialog_container, {
      dialogType: "create",
      isOpen: _ctx.createDialog,
      "onUpdate:isOpen": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.createDialog) = $event))
    }, null, 8, ["isOpen"]),
    _createVNode(_component_class_dialog_container, {
      dialogType: "update",
      isOpen: _ctx.updateDialog,
      "onUpdate:isOpen": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.updateDialog) = $event))
    }, null, 8, ["isOpen"])
  ]))
}